/**Nhap danh muc chu tau */
import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormLabel,
  OutlinedInput,
  InputBase,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SelectFilter from "react-select";

/*----------------------Cac control trong project su dung den trong form----------------*/
import {
  filterStyles,
  formStyles,
  loadDataError,
  handleServerError,
  ReactDataGrid_i18n,
  showError,
} from "../components/common";
import SimpleDialog from "../components/SimpleDialog";
import MyNumberEditor from "../components/MyNumberEditor";
import MyDateEditor from "../components/MyDateEditor";
import MyDateTimeEditor from "../components/MyDateTimeEditor";
import MyLatLonEditor from "../components/MyLatLonEditor";
/*-----------------------Cac thu vien dung chung -------------------------*/
const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const dataStruct = require("../data/DataStruct");
/*-----------------------Cac dinh nghia ----------------------------------*/
const englishUI = true;

/*-----------------------Dinh nghia cac label tieng Anh, tieng Viet su dung trong form*/
const formTitle = englishUI ? "SHIP INFO" : "THÔNG TIN TÀU";
const fieldLabels = englishUI
  ? {
    ShipID: "ShipID",
    ShipCode: "Code:",
    ShipName: "Ship' name:",
    CallSign: "Callsign:",
    IMO: "IMO:",
    MMSI: "MMSI:",
    DWT: "DWT:",
    GT: "GRT:",
    DWT: "DWT:",

    ShipType: "Ship type:",
    PowerMEKW: "ME-Power-KW:",
    Auxility: "Auxility:",
    MainEnginePower: "ME-Power-RPM:",

    SlipH: "Slip-H:",
    NumOfGE: "Num.of GE:",

    FlowME: "FM-ME",
    FlowAE: "FM-AE",
    FlowBLR: "FM-BL",
    Flow2: "FM-ME+AE",
    Flow3: "FM-Total",
    CII: "CII factor:",
    CII_Ref: "Ref:",
    CII_D1: "D1:",
    CII_D2: "D2:",
    CII_D3: "D3:",
    CII_D4: "D4:",
    NguoiCN: "NguoiCN",
    NgayCN: "NgayCN",
    PowerExpression: "PowerExpression",
    OrderUI: "Order:",
    Emails: "Report to emails:",
  }
  : {
    ShipID: "ShipID",
    ShipCode: "Ký hiệu:",
    ShipName: "Tên tàu:",
    CallSign: "Hô hiệu:",
    IMO: "IMO:",
    MMSI: "MMSI:",
    DWT: "DWT:",
    GT: "GRT:",
    ShipType: "Ship type:",
    PowerMEKW: "ME-Power-KW:",
    Auxility: "Auxility:",
    MainEnginePower: "ME-Power-RPM:",

    SlipH: "Slip-H:",
    NumOfGE: "Num.of GE:",
    FlowME: "FM-ME",
    FlowAE: "FM-AE",
    FlowBLR: "FM-BL",
    Flow2: "FM-ME+AE",
    Flow3: "FM-Total",
    CII: "Hệ số CII:",
    CII_Ref: "Ref:",
    CII_D1: "D1:",
    CII_D2: "D2:",
    CII_D3: "D3:",
    CII_D4: "D4:",
    NguoiCN: "NguoiCN",
    NgayCN: "NgayCN",
    PowerExpression: "PowerExpression",
    OrderUI: "Order:",
    Emails: "Report to emails:",
  };
const buttonLabels = englishUI
  ? {
    btnSave: "Save",
    btnClose: "Close",
  }
  : {
    btnSave: "Lưu",
    btnClose: "Thoát",
  };

function validate_Data(data) {
  var ret = myLib.validateEmpty(data, ["ShipCode", "ShipName"]);
  if (Object.keys(ret).length == 0) {
    //ko co loi thi kiem tra cac dieu kien khac
  }

  ret.error = Object.keys(ret).length > 0;
  ret.GUID = new Date(); //danh dau version
  return ret;
}
const defaultEmails = () => [

];
////////////////////////--------------/////////////////////////////////////////
export default class ShipEditDialog extends React.Component {
  constructor(props) {
    super(props);
    var emails =
      props.edittingRecord !== undefined
        ? JSON.parse(props.edittingRecord.Emails)
        : [];
    if (emails.length == 0) {
      emails = defaultEmails();
    }
    this.state = {
      validateStatus: { error: false }, //trang thai validate
      DanhMuc: { DM_ReportType: [] },
      after: {
        ShipID: 0,
        ShipCode: "",
        ShipName: "",
        CallSign: "",
        IMO: "",
        MMSI: "",
        DWT: null,
        GT: null,
        OrderUI: 0,
        FlowME: false,
        FlowAE: false,
        FlowBLR: false,
        Flow2: false,
        Flow3: false,
        ...(props.edittingRecord ? props.edittingRecord : {}),
        ...{
          NumOfGE: 1,
          ...(props.edittingRecord && props.edittingRecord.FMEnable
            ? JSON.parse(props.edittingRecord.FMEnable)
            : {}),
        },
        Emails: emails,
      },
    };
  }

  componentDidMount() {
    this.loadDanhMuc();
  }
  loadDanhMuc() {
    server
      .post("Data/DoRequest", {
        Function: "Proc_Table_GetAll",
        ThamSo: {
          TableNames: "DM_ReportType",
        },
      })
      .then((response) => {
        //gien thi them neu ko co
        var emails = this.state.after.Emails;
        response.DM_ReportType.map((item) => {
          var old = emails.find((e) => e.ReportTypeID === item.ReportTypeID);
          if (old === undefined || old === null) {
            emails.push({
              ReportTypeID: item.ReportTypeID,
              Emails: "",
            });
          }
        });
        this.setState({
          DanhMuc: {
            ...response,
          },
        });
      })
      .catch((error) => {
        showError(error);
      });
  }
  //call khi user thay doi trang
  static getDerivedStateFromProps(nextProps, prevState) {
    return { open: nextProps.open };
  }
  saveField = (fieldName, value) => {
    var old_changed = this.state.dataChanged;
    var s = { after: { ...this.state.after } }; //new value
    s.after[fieldName] = value;
    s.dataChanged = true;
    this.setState(s);
  };
  saveData = (obj) => {
    var old_changed = this.state.dataChanged;
    var s = {};
    s.dataChanged = true;
    s.canSaved = s.dataChanged;
    s.after = { ...this.state.after, ...obj };
    this.setState(s);
  };
  doSave = () => {
    try {
      var check = validate_Data(this.state.after);
      var action = this.state.after.ShipID > 0 ? "update" : "insert";
      if (!check.error) {
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post("Data/DoRequest", {
            Function: "Proc_DM_Ship_Update",
            ThamSo: this.state.after,
          })
          .then((response) => {
            var before = {};
            var after = {
              ...this.state.after,
              ShipID: response.ShipID,
            };
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorMessage: "",
              errorLog: "",
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(action, after);
            }
            alert("Cập nhật thành công!");
            this.props.close(after);
          })
          .catch((error) => {
            handleServerError(error);
            this.setState({ saving: false });
          });
      } else {
        this.setState({ validateStatus: check });
        showError("Vui lòng kiểm tra các trường đánh dấu đỏ!");
      }
    } catch (ex) {
      showError(ex);
    }
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        maxWidth={"md"}
        fullWidth={true}
        onClose={() => { }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{formTitle}</DialogTitle>
        <DialogContent>
          <div
            style={{
              minWidth: 500,
              minHeight: 30,
              padding: 5,
              fontSize: 10,
              wordWrap: "break-word",
            }}
          >
            <Grid container spacing={1} columns={24}>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.ShipCode}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <OutlinedInput
                  id="txtShipCode"
                  fullWidth
                  autoFocus
                  inputProps={{
                    style: { textTransform: "uppercase" },

                    maxLength: 20,
                  }}
                  value={this.state.after.ShipCode}
                  onChange={(event) => {
                    this.saveField(
                      "ShipCode",
                      myLib.toUpperCase(event.target.value)
                    );
                  }}
                  error={this.state.validateStatus.ShipCode !== undefined}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.ShipName}</FormLabel>
              </Grid>
              <Grid item xs={12}>
                <OutlinedInput
                  id="txtShipName"
                  fullWidth
                  inputProps={{
                    style: { textTransform: "uppercase" },

                    maxLength: 40,
                  }}
                  value={this.state.after.ShipName}
                  onChange={(event) => {
                    this.saveField(
                      "ShipName",
                      myLib.toUpperCase(event.target.value)
                    );
                  }}
                  error={this.state.validateStatus.ShipName !== undefined}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.CallSign}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <OutlinedInput
                  id="txtCallSign"
                  fullWidth
                  inputProps={{
                    style: { textTransform: "uppercase" },

                    maxLength: 40,
                  }}
                  value={this.state.after.CallSign}
                  onChange={(event) => {
                    this.saveField("CallSign", event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.IMO}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <OutlinedInput
                  id="txtIMO"
                  fullWidth
                  inputProps={{
                    style: { textTransform: "uppercase" },

                    maxLength: 9,
                  }}
                  value={this.state.after.IMO}
                  onChange={(event) => {
                    this.saveField("IMO", event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.MMSI}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <OutlinedInput
                  id="txtMMSI"
                  fullWidth
                  inputProps={{
                    style: { textTransform: "uppercase" },

                    maxLength: 9,
                  }}
                  value={this.state.after.MMSI}
                  onChange={(event) => {
                    this.saveField("MMSI", event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.ShipType}</FormLabel>
              </Grid>
              <Grid item xs={12}>
                <OutlinedInput
                  id="txtShiptype"
                  fullWidth

                  value={this.state.after.ShipType}
                  onChange={(event) => {
                    this.saveField("ShipType", event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.DWT}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <MyNumberEditor
                  id="txtDWT"
                  fullWidth
                  value={this.state.after.DWT}
                  onValueChange={(value) => {
                    this.saveField("DWT", value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.GT}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <MyNumberEditor
                  id="txtGT"
                  fullWidth
                  value={this.state.after.GT}
                  onValueChange={(value) => {
                    this.saveField("GT", value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.SlipH}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <MyNumberEditor
                  id="SlipH"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.SlipH}
                  onValueChange={(value) => {
                    this.saveField("SlipH", value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.NumOfGE}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <MyNumberEditor
                  id="NumOfGE"
                  fullWidth
                  decimalScale={0}
                  value={this.state.after.NumOfGE}
                  onValueChange={(value) => {
                    this.saveField("NumOfGE", value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.PowerMEKW}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <MyNumberEditor
                  id="PowerMEKW"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.PowerMEKW}
                  onValueChange={(value) => {
                    this.saveField("PowerMEKW", value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.Auxility}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <OutlinedInput
                  id="Auxility"
                  fullWidth

                  value={this.state.after.Auxility}
                  onChange={(event) => {
                    this.saveField("Auxility", event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.MainEnginePower}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <OutlinedInput
                  id="MainEnginePower"
                  fullWidth

                  value={this.state.after.MainEnginePower}
                  onChange={(event) => {
                    this.saveField("MainEnginePower", event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  label={fieldLabels.FlowME}
                  labelPlacement="end"
                  fullWidth
                  control={
                    <Checkbox
                      size="medium"
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                      checked={this.state.after.FlowME}
                      onChange={(event) => {
                        this.saveField("FlowME", event.target.checked);
                      }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  label={fieldLabels.FlowAE}
                  labelPlacement="end"
                  fullWidth
                  control={
                    <Checkbox
                      size="medium"
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                      checked={this.state.after.FlowAE}
                      onChange={(event) => {
                        this.saveField("FlowAE", event.target.checked);
                      }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  label={fieldLabels.FlowBLR}
                  labelPlacement="end"
                  fullWidth
                  control={
                    <Checkbox
                      size="medium"
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                      checked={this.state.after.FlowBLR}
                      onChange={(event) => {
                        this.saveField("FlowBLR", event.target.checked);
                      }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  label={fieldLabels.Flow2}
                  labelPlacement="end"
                  fullWidth
                  control={
                    <Checkbox
                      size="medium"
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                      checked={this.state.after.Flow2}
                      onChange={(event) => {
                        this.saveField("Flow2", event.target.checked);
                      }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  label={fieldLabels.Flow3}
                  labelPlacement="end"
                  fullWidth
                  control={
                    <Checkbox
                      size="medium"
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
                      checked={this.state.after.Flow3}
                      onChange={(event) => {
                        this.saveField("Flow3", event.target.checked);
                      }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.CII}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                <FormLabel>{fieldLabels.CII_Ref}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                <MyNumberEditor
                  id="CII_Ref"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.CII_Ref}
                  onValueChange={(value) => {
                    this.saveField("CII_Ref", value);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <FormLabel>{fieldLabels.CII_D1}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                <MyNumberEditor
                  id="CII_D1"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.CII_D1}
                  onValueChange={(value) => {
                    this.saveField("CII_D1", value);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <FormLabel>{fieldLabels.CII_D2}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                <MyNumberEditor
                  id="CII_D2"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.CII_D2}
                  onValueChange={(value) => {
                    this.saveField("CII_D2", value);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <FormLabel>{fieldLabels.CII_D3}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                <MyNumberEditor
                  id="CII_D3"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.CII_D3}
                  onValueChange={(value) => {
                    this.saveField("CII_D3", value);
                  }}
                />
              </Grid>
              <Grid item xs={2}>
                <FormLabel>{fieldLabels.CII_D4}</FormLabel>
              </Grid>
              <Grid item xs={2}>
                <MyNumberEditor
                  id="CII_D4"
                  fullWidth
                  decimalScale={4}
                  value={this.state.after.CII_D4}
                  onValueChange={(value) => {
                    this.saveField("CII_D4", value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormLabel>{fieldLabels.OrderUI}</FormLabel>
              </Grid>
              <Grid item xs={4}>
                <MyNumberEditor
                  id="OrderUI"
                  fullWidth
                  decimalScales={0}
                  value={this.state.after.OrderUI}
                  onValueChange={(value) => {
                    this.saveField("OrderUI", value);
                  }}
                />
              </Grid>

            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.doSave();
            }}
            variant="contained"
          >
            {buttonLabels.btnSave}
          </Button>
          <Button
            onClick={() => {
              if (this.props.close) {
                this.props.close(false);
              }
            }}
            variant="contained"
          >
            {buttonLabels.btnClose}
          </Button>
        </DialogActions>
        
      </Dialog>
    );
  }
}
